import type { ApprovalStage, StartWorkflowRequest } from '@/types/workflow'

export type WorkflowGenerationIntent = 'start' | 'approve' | 'revise' | 'resume'

export interface WorkflowGenerationAction {
  intent: WorkflowGenerationIntent
  stage?: ApprovalStage
  revisionTargetStage?: ApprovalStage
  feedback?: string
  editedContent?: string
  textModelId?: string
  startRequest?: StartWorkflowRequest
  createdAt: number
}

const STORAGE_PREFIX = 'workflow-generation-action:'

export function buildGenerationRoute(projectId: string | number, action?: Partial<WorkflowGenerationAction>): string {
  const params = new URLSearchParams()
  if (action?.intent) {
    params.set('intent', action.intent)
  }
  if (action?.stage) {
    params.set('stage', action.stage)
  }
  const query = params.toString()
  return `/generation/${projectId}${query ? `?${query}` : ''}`
}

export function queueGenerationAction(projectId: string | number, action: Omit<WorkflowGenerationAction, 'createdAt'>) {
  if (typeof window === 'undefined') {
    return
  }

  const payload: WorkflowGenerationAction = {
    ...action,
    createdAt: Date.now(),
  }
  window.sessionStorage.setItem(`${STORAGE_PREFIX}${projectId}`, JSON.stringify(payload))
}

export function consumeGenerationAction(projectId: string | number): WorkflowGenerationAction | null {
  if (typeof window === 'undefined') {
    return null
  }

  const key = `${STORAGE_PREFIX}${projectId}`
  const raw = window.sessionStorage.getItem(key)
  if (!raw) {
    return null
  }

  window.sessionStorage.removeItem(key)

  try {
    return JSON.parse(raw) as WorkflowGenerationAction
  } catch {
    return null
  }
}

export function shouldUseGenerationWorkspace(stage?: ApprovalStage | null): boolean {
  return stage !== 'final'
}
